import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { RuleCard } from "./rule-card"
import { RuleSetReferenceCard } from "./rule-set-reference-card"

export function RuleSetItem({ item, onUpdate, onRemove, onDuplicate, readOnly }) {
    return (
        <If value={item.type === "ruleSetReference"}>
            <RuleSetReferenceCard item={item} onUpdate={onUpdate} onRemove={onRemove} readOnly={readOnly} />
            <Else>
                <RuleCard
                    item={item}
                    onUpdate={onUpdate}
                    onRemove={onRemove}
                    onDuplicate={onDuplicate}
                    readOnly={readOnly}
                />
            </Else>
        </If>
    )
}
